import { selectStandardProps } from "@/utils/componentUtils";
import { Form, Select } from "antd";
import { FormItemProps } from "antd/lib/form";
import { SelectProps } from "antd/lib/select";
import { useCallback } from "react";
import { useEnumeration } from "../../../../common/api/queries";
import type { UUID } from "../../../../typings/global";
import { formatAgentName } from "../../../agent/utils";
import { EnumerationType } from "../../enums";
import { AgentEnumeration, FilterFunction } from "../../types";

interface Props {
  formItemProps: FormItemProps;
  selectProps?: SelectProps<string>;
  optionsProps?: AgentOptionsProps;
}

interface AgentOptionsProps {
  filter?: FilterFunction<AgentEnumeration>;
  onChange?: (agent: AgentEnumeration) => void;
}

export const TopAgentSelect = ({ formItemProps, selectProps, optionsProps }: Props) => {
  const topAgentEnums = useEnumeration(EnumerationType.TOP_AGENTS);

  const resolveAgentSelectOptions = useCallback((): AgentEnumeration[] => {
    let options = [...topAgentEnums];

    if (optionsProps?.filter) {
      options = options.filter(optionsProps.filter);
    }

    return options;
  }, [topAgentEnums, optionsProps]);

  const onChange = (agentId: UUID, option: any) => {
    selectProps?.onChange?.(agentId, option);
    const topAgent = topAgentEnums.find((agent) => agent.id === agentId);

    if (topAgent) {
      optionsProps?.onChange?.(topAgent);
    }
  };

  return (
    <Form.Item {...formItemProps}>
      <Select
        {...selectStandardProps}
        {...selectProps}
        onChange={onChange}
        options={resolveAgentSelectOptions().map((agent) => ({
          value: agent.id,
          label: formatAgentName(agent),
        }))}
      />
    </Form.Item>
  );
};
